const CalendarConstants = {
  SESSION_NOTIFICATION_SOUNDS: {
    0: () => import("@assets/audio/SessionStartSoundBeginnings.mp3"),
    1: () => import("@assets/audio/SessionStartSoundTwinkles.mp3"),
    2: () => import("@assets/audio/SessionStartSoundBells.mp3"),
    3: () => import("@assets/audio/SessionStartSoundManyBells.mp3"),
    4: () => import("@assets/audio/SessionStartSoundChords.mp3"),
    5: () => import("@assets/audio/SessionStartSoundDramaticAscent.mp3"),
    6: () => import("@assets/audio/SessionStartSoundMagicalSprinkles.mp3"),
    7: () => import("@assets/audio/SessionStartSoundMysticalGong.mp3"),
    8: () => import("@assets/audio/SessionStartSoundLightGong.mp3"),
    9: () => import("@assets/audio/SessionStartSoundPleasantAnnouncement.mp3"),
    10: () => import("@assets/audio/SessionStartSoundSuddenAnnouncement.mp3"),
    11: () => import("@assets/audio/SessionStartSoundStinger.mp3"),
    12: () => import("@assets/audio/SessionStartSoundSynth.mp3"),
    13: () => import("@assets/audio/SessionStartSoundTheHeavens.mp3"),
    14: () => import("@assets/audio/SessionStartSoundGoodThingsAhead.mp3"),
    15: () => import("@assets/audio/SessionStartSoundBecauseWhyNot.mp3"),
    16: () => import("@assets/audio/SessionStartSoundIAmAnAgent.mp3"),
  },
};

export default CalendarConstants;
